import { SignupContext } from "../../types/data";

export const createBuyNowQuery = (signupContext: SignupContext): string => {
  const paramArray = [`businessModule=${signupContext.businessModule ?? "plus"}`];
  if (signupContext.billingCycle) {
    paramArray.push(`billingCycle=${signupContext.billingCycle}`);
  }
  paramArray.push(`disableTrial=${!signupContext.isTrial}`);
  return paramArray.join("&");
};
